export default "__VITE_ASSET__gTl6ripx__"